(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('prop-types')) :
  typeof define === 'function' && define.amd ? define(['react', 'prop-types'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global["dist/index"] = global["dist/index"] || {}, global["dist/index"].js = factory(global.React, global.PropTypes)));
})(this, (function (React, PropTypes) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var types = {
    SET_MODAL_OPEN: 'SET_MODAL_OPEN',
    SET_MODAL_CLOSE: 'SET_MODAL_CLOSE'
  };
  var actions = {
    setModalOpen: function setModalOpen() {
      return {
        type: types.SET_MODAL_OPEN
      };
    },
    setModalClose: function setModalClose() {
      return {
        type: types.SET_MODAL_CLOSE
      };
    }
  };

  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') {
      return;
    }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z = ".pop_up_modal_container {\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-animation: fade 0.3s;\n          animation: fade 0.3s; }\n  .pop_up_modal_container.hide {\n    display: none; }\n  .pop_up_modal_container.show {\n    display: block; }\n  .pop_up_modal_container .pop_up_modal_body {\n    position: relative;\n    margin: auto;\n    z-index: 1050;\n    margin-bottom: 2rem;\n    opacity: 1;\n    overflow: auto; }\n    .pop_up_modal_container .pop_up_modal_body.sm {\n      max-width: 360px;\n      min-width: 360px;\n      top: 25%; }\n    .pop_up_modal_container .pop_up_modal_body.md {\n      max-width: 480px;\n      min-width: 360px;\n      top: 15%; }\n    .pop_up_modal_container .pop_up_modal_body.lg {\n      max-width: 640px;\n      min-width: 360px;\n      top: 6%; }\n    .pop_up_modal_container .pop_up_modal_body.xl {\n      max-width: 1300px;\n      min-width: 640px;\n      top: 6%; }\n    .pop_up_modal_container .pop_up_modal_body.overflow {\n      overflow: visible !important; }\n\n@-webkit-keyframes fade {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes fade {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n";
  styleInject(css_248z);

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  var dist = {exports: {}};

  (function (module, exports) {
  (function (global, factory) {
    module.exports = factory(React__default["default"], PropTypes__default["default"]) ;
  })(commonjsGlobal, function (React, PropTypes) {

    function _interopDefaultLegacy(e) {
      return e && typeof e === 'object' && 'default' in e ? e : {
        'default': e
      };
    }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

    var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

    var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};
    var dist = {
      exports: {}
    };

    (function (module, exports) {
      (function (global, factory) {
        factory(exports, React__default["default"], PropTypes__default["default"]);
      })(commonjsGlobal$1, function (exports, React, PropTypes) {
        function _interopDefaultLegacy(e) {
          return e && typeof e === 'object' && 'default' in e ? e : {
            'default': e
          };
        }

        var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

        var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
        /* eslint-disable */


        function ActiveExistingMerchantIcon(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "a",
            d: "M0-38.1h82.173v82.173H0z",
            transform: "translate(0 38.1)"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            "clip-path": "url(#a)"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "a",
            d: "M53.261 56.36v-7.516a.761.761 0 00-1.522 0v5.326c-1.469 0-3.043-2.679-3.043-4.565V41.83c6.674 2.5 9.13 8.014 9.13 12.34 0 1.109-1.576 1.859-4.565 2.19m-12.929 2.375c-4.892 0-10.254-.624-11.419-1.815v-1.229c3.072 0 4.565-1.991 4.565-6.087h13.7c0 2.452 1.917 6.087 4.565 6.087v1.017c-.026.027-.06.044-.081.076-.915 1.34-6.512 1.95-11.326 1.95M22.821 54.17c0-4.326 2.456-9.839 9.13-12.337v7.771c0 4.212-1.571 4.565-3.043 4.565v-5.325a.761.761 0 00-.761-.761.761.761 0 00-.761.761v7.532c-3.018-.313-4.565-1.05-4.565-2.206m12.922-8.048a.755.755 0 00.583.489.746.746 0 00.717-.259l3.292-3.941 3.409 3.95a.759.759 0 00.576.264.789.789 0 00.145-.014.763.763 0 00.575-.5l1.666-4.9c.158.04.313.083.467.126v6.745h-13.7v-6.741c.162-.046.326-.089.492-.132zm-.422-6.871l3.838 2.193-2.438 2.915-1.66-4.6zm5-.3a5.643 5.643 0 003.837-1.742 5.724 5.724 0 00.161.871l-3.998 2.279-3.982-2.278a5.869 5.869 0 00.155-.87 5.642 5.642 0 003.827 1.741m-5.734-7.524a4.113 4.113 0 01-1.109-2.367c0-1.3.236-1.522.761-1.522a11.014 11.014 0 007.421-3.254c.747 1.268 2.306 3.254 4.752 3.254.526 0 .761.22.761 1.522a4.1 4.1 0 01-1.107 2.365.762.762 0 00-.369.425c-1.186 3.337-3.343 5.58-5.376 5.58s-4.181-2.243-5.365-5.58a.762.762 0 00-.369-.423m5.734-12.258c5.2 0 6.491 4.13 6.773 6.944a2.582 2.582 0 00-.686-.1c-2.485 0-3.846-3.294-3.859-3.327a.761.761 0 00-.6-.468.755.755 0 00-.7.276c-.027.036-2.863 3.519-7.014 3.519a2.572 2.572 0 00-.686.1c.286-2.817 1.582-6.944 6.772-6.944m5.014 20.082l.256.515-1.563 4.593-2.522-2.922zm1.825.507a.741.741 0 00-.065-.384l-.755-1.522a.636.636 0 00-.606-.4 3.96 3.96 0 01-.082-.78v-1.291a14.194 14.194 0 001.405-2.82 5.54 5.54 0 001.638-3.5 5.694 5.694 0 00-.112-1.147.744.744 0 00.112-.374c0-6.195-3.129-9.891-8.37-9.891s-8.37 3.7-8.37 9.891a.744.744 0 00.112.374 5.694 5.694 0 00-.112 1.147 5.541 5.541 0 001.639 3.5 14.152 14.152 0 001.4 2.82v1.288a4.119 4.119 0 01-.078.78.821.821 0 00-.143.014.762.762 0 00-.46.388l-.761 1.522a.749.749 0 00-.065.39c-8.966 2.301-12.183 9.133-12.183 14.406 0 3.125 4.551 3.63 6.481 3.779 2.055 2.075 9.384 2.308 12.547 2.308 3.1 0 10.285-.233 12.328-2.308 1.983-.152 6.687-.664 6.687-3.779 0-5.267-3.218-12.111-12.188-14.41",
            fill: "#00677F"
          })));
        }

        ActiveExistingMerchantIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ActiveExistingMerchantIcon.defaultProps = {
          width: '84',
          height: '84'
        };
        /* eslint-disable */

        function CheckIcon(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0-16.556h34.409v34.409H0z",
            transform: "translate(0 16.556)"
          })), /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "b"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M34.409 17.853z",
            transform: "translate(0 16.556)"
          }))), /*#__PURE__*/React__default["default"].createElement("path", {
            style: {
              fill: 'none',
              stroke: '#1da897',
              strokeWidth: '1.25px'
            },
            d: "M17.423 30.108a12.903 12.903 0 010-25.807 12.903 12.903 0 110 25.807"
          }), /*#__PURE__*/React__default["default"].createElement("g", {
            "clip-path": "url(#b)",
            transform: "translate(.218)"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            style: {
              fill: 'none',
              stroke: '#1da897',
              strokeWidth: '1.25px'
            },
            d: "M17.205 30.108a12.903 12.903 0 010-25.807 12.903 12.903 0 110 25.807"
          })), /*#__PURE__*/React__default["default"].createElement("g", null, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M9.057 18.799l6.523 5.554 9.258-13.965",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.06",
            fill: "none",
            stroke: "#1da897"
          })));
        }

        CheckIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        CheckIcon.defaultProps = {
          width: '34.627',
          height: '34.409'
        };
        /* eslint-disable */

        function ChevronCancel() {
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "48.08",
            height: "48.08",
            viewBox: "0 0 12.721 12.721"
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a",
            clipPathUnits: "userSpaceOnUse"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0 72h72V0H0z"
          })), /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "b",
            clipPathUnits: "userSpaceOnUse"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0 72h72V0H0z"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            "clip-path": "url(#a)",
            transform: "matrix(.22994 0 0 -.22994 -1.903 14.644)",
            fill: "none",
            stroke: "#ef413d"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M36 9C21.112 9 9 21.115 9 36 9 50.89 21.112 63 36 63S63 50.89 63 36C63 21.115 50.888 9 36 9",
            "stroke-width": "2.175"
          })), /*#__PURE__*/React__default["default"].createElement("g", {
            "clip-path": "url(#b)",
            transform: "matrix(.22994 0 0 -.22994 -2.008 14.644)",
            fill: "#ef413d"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M37.956 36.001l12.91 12.908a1.175 1.175 0 010 1.662l-.297.295a1.175 1.175 0 01-1.662 0L36 37.959 23.091 50.866a1.175 1.175 0 01-1.662 0l-.297-.295a1.175 1.175 0 010-1.662L34.04 36.001 21.132 23.092a1.175 1.175 0 010-1.662l.297-.295a1.175 1.175 0 011.662 0L36 34.043l12.908-12.908a1.175 1.175 0 011.662 0l.297.295a1.175 1.175 0 010 1.662z"
          })));
        }
        /* eslint-disable */


        function ChevronClose(props) {
          var width = props.width,
              height = props.height,
              color = props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            style: {
              fill: color
            },
            d: "M0-25.4h30.758V5.358H0z",
            transform: "translate(0 25.4)"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            clipPath: "url(#a)"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            style: {
              fill: color
            },
            d: "M16.216 15.379l5.515-5.514a.5.5 0 000-.71l-.127-.126a.5.5 0 00-.71 0l-5.514 5.518-5.515-5.518a.5.5 0 00-.71 0l-.127.126a.5.5 0 000 .71l5.51 5.514-5.51 5.515a.5.5 0 000 .71l.127.126a.5.5 0 00.71 0l5.515-5.515 5.514 5.515a.5.5 0 00.71 0l.127-.126a.5.5 0 000-.71z"
          })));
        }

        ChevronClose.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ChevronClose.defaultProps = {
          width: '30.758',
          height: '30.758',
          color: '#fff'
        };
        /* eslint-disable */

        function ChevronCopyIcon(props) {
          var width = props.width;
          props.height;
          var color = props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            viewBox: "0 0 20.322 12.594"
          }, /*#__PURE__*/React__default["default"].createElement("g", {
            transform: "matrix(.28623 0 0 -.28623 -5.617 22.458)",
            fill: color
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M57.278 60.201c.555 0 1.004.45 1.004 1.002v.046a1.003 1.003 0 01-2.008 0v-.046c0-.553.45-1.002 1.004-1.002M57.278 63.678c.555 0 1.004.448 1.004 1.002v.096a1.003 1.003 0 01-2.008 0v-.096c0-.554.45-1.002 1.004-1.002M57.278 70.731c.555 0 1.004.45 1.004 1.003v.096c0 .554-.449 1.002-1.004 1.002a1.003 1.003 0 01-1.004-1.002v-.096c0-.554.45-1.003 1.004-1.003M57.278 67.204c.555 0 1.004.45 1.004 1.003v.096a1.003 1.003 0 01-2.008 0v-.096c0-.554.45-1.003 1.004-1.003M57.196 74.263a1.002 1.002 0 011.092.905l.007.057a1.003 1.003 0 01-1.99.265l-.015-.136a1.001 1.001 0 01.906-1.091M59.665 76.453H59.749a1.002 1.002 0 110 2.006h-.045l-.005-.002-.005.002h-.047a1.004 1.004 0 01.018-2.006M69.83 78.459h-.093a1.004 1.004 0 110-2.006h.092a1.003 1.003 0 110 2.006M76.55 78.459h-.093a1.004 1.004 0 01-1.004-1.003c0-.554.45-1.003 1.004-1.003h.093a1.004 1.004 0 010 2.006M79.473 76.523a.982.982 0 01.444-.114c.553 0 1.003.448 1.003 1.003v.045c0 .552-.45 1.002-1.003 1.002h-.004a.004.004 0 00-.003 0h-.092c-.555 0-1.004-.45-1.004-1.002 0-.433.275-.793.659-.934M84.19 72.577a1.003 1.003 0 011.42 1.417l-.066.066a1.003 1.003 0 01-1.419-1.417zM86.566 70.204a1.003 1.003 0 011.42 1.417l-.066.066a1.002 1.002 0 11-1.419-1.418zM81.814 74.95a1.003 1.003 0 011.42 1.418l-.066.065a1.003 1.003 0 01-1.419-1.418zM66.377 76.453h.093c.553 0 1.004.45 1.004 1.003 0 .554-.451 1.003-1.004 1.003h-.093a1.003 1.003 0 110-2.006M73.189 78.459h-.092a1.004 1.004 0 01-1.004-1.003c0-.554.45-1.003 1.003-1.003h.093a1.003 1.003 0 110 2.006M63.017 76.453h.093c.553 0 1.004.45 1.004 1.003 0 .554-.451 1.003-1.004 1.003h-.093a1.004 1.004 0 010-2.006M90.622 68.572c0 .264-.105.521-.293.71l-.03.03a1.004 1.004 0 01-1.42.002.994.994 0 01-.202-1.117.983.983 0 01-.108-.433c0-.553.45-1.003 1.004-1.003h.045a1.004 1.004 0 01.927 1.385c.05.117.077.246.077.381zM58.323 37.543l-.012.052a1.003 1.003 0 01-1.966-.406l.03-.124a1.003 1.003 0 111.949.478M59.743 36.464h-.068a1.002 1.002 0 11-.04-2.005H59.742a1.003 1.003 0 110 2.005M57.278 39.557c.555 0 1.004.449 1.004 1.002v.09a1.003 1.003 0 01-2.008 0v-.09c0-.553.45-1.002 1.004-1.002M58.282 47.17a1.003 1.003 0 01-2.008 0v-.09a1.004 1.004 0 012.008 0zM57.278 44.912a1.004 1.004 0 01-1.004-1.003v-.089c0-.554.45-1.002 1.004-1.002.555 0 1.004.448 1.004 1.002v.09c0 .553-.449 1.002-1.004 1.002M63.009 36.464h-.09a1.003 1.003 0 110-2.005h.09a1.003 1.003 0 110 2.005M89.618 50.053a1.002 1.002 0 01-1.003-1.002v-.09a1.003 1.003 0 112.007 0v.09c0 .554-.449 1.002-1.004 1.002M89.618 66.358a1.003 1.003 0 01-1.003-1.003v-.089a1.004 1.004 0 012.007 0v.09c0 .553-.449 1.002-1.004 1.002M89.618 43.531a1.003 1.003 0 01-1.003-1.002v-.09a1.003 1.003 0 012.007 0v.09c0 .553-.449 1.002-1.004 1.002M89.618 46.793a1.003 1.003 0 01-1.003-1.003v-.089a1.004 1.004 0 012.007 0v.089c0 .554-.449 1.003-1.004 1.003M89.618 40.27a1.003 1.003 0 01-1.003-1.003v-.089a1.003 1.003 0 112.007 0v.09c0 .553-.449 1.002-1.004 1.002M89.618 53.315a1.003 1.003 0 01-1.003-1.002v-.09a1.003 1.003 0 012.007 0v.09c0 .552-.449 1.001-1.004 1.001M89.618 59.836a1.003 1.003 0 01-1.003-1.002v-.09a1.003 1.003 0 012.007 0v.09c0 .553-.449 1.002-1.004 1.002M89.618 63.098a1.003 1.003 0 01-1.003-1.003v-.09a1.003 1.003 0 112.007 0v.09c0 .554-.449 1.003-1.004 1.003M89.618 56.575a1.002 1.002 0 01-1.003-1.003v-.088a1.003 1.003 0 112.007 0v.088c0 .555-.449 1.003-1.004 1.003M88.21 36.89l-.037-.036a1 1 0 01-.037-1.417 1.004 1.004 0 011.418-.036l.09.088a1.003 1.003 0 11-1.434 1.402M82.597 36.464h-.09a1.004 1.004 0 110-2.005h.09a1.003 1.003 0 110 2.005M72.802 36.464h-.09a1.003 1.003 0 110-2.005h.09a1.003 1.003 0 110 2.005M69.538 36.464h-.09a1.004 1.004 0 110-2.005h.09a1.003 1.003 0 010 2.005M66.272 36.464h-.089a1.004 1.004 0 110-2.005h.09a1.003 1.003 0 110 2.005M79.331 36.464h-.089a1.004 1.004 0 110-2.005h.09a1.003 1.003 0 110 2.005M76.067 36.464h-.09a1.003 1.003 0 110-2.005h.09a1.003 1.003 0 110 2.005M85.86 36.464h-.089a1.003 1.003 0 110-2.005h.09a1.003 1.003 0 110 2.005M58.282 50.401a1.003 1.003 0 01-2.008 0v-.045a1.004 1.004 0 012.008 0zM80.92 74.44a1.004 1.004 0 01-2.007 0v-.084a1.003 1.003 0 012.008 0zM86.592 68.768h-.083a1.003 1.003 0 110-2.005h.083a1.003 1.003 0 110 2.005M83.533 68.768h-.083a1.003 1.003 0 110-2.005h.083a1.003 1.003 0 110 2.005M79.917 72.387a1.003 1.003 0 01-1.004-1.002V71.3c0-.554.449-1.002 1.004-1.002.554 0 1.004.448 1.004 1.002v.084c0 .553-.45 1.002-1.004 1.002M81.353 69.168l-.035.035a1.003 1.003 0 11-1.445-1.391l.084-.083a1.003 1.003 0 111.396 1.439M51.352 68.768H45.69a1.423 1.423 0 00-1.422 1.42v5.656zm1.615-17.363a1.003 1.003 0 01-1.005-1.003V37.885a1.424 1.424 0 00-1.42-1.421h-27.49a1.424 1.424 0 00-1.422 1.42v37.15a1.424 1.424 0 001.422 1.42H42.26v-6.266a3.428 3.428 0 013.43-3.425h6.272v-6.67a1.003 1.003 0 012.007 0v8.48c0 .264-.107.523-.293.709l-8.894 8.883a1.013 1.013 0 01-.71.294h-21.02a3.429 3.429 0 01-3.43-3.425v-37.15a3.429 3.429 0 013.43-3.425h27.49a3.428 3.428 0 013.427 3.426v12.517c0 .554-.449 1.003-1.003 1.003"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M66.983 56.25H45.151a1.003 1.003 0 110-2.006h21.832l-4.756-4.748a1.006 1.006 0 010-1.418 1.006 1.006 0 011.42 0l6.468 6.461a1.009 1.009 0 01.217 1.092c-.05.119-.122.224-.21.315l-.007.01-6.468 6.461a1.004 1.004 0 01-1.42 0 1.004 1.004 0 010-1.417z"
          })));
        }

        ChevronCopyIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ChevronCopyIcon.defaultProps = {
          width: '30',
          height: '12.39',
          color: '#ffffff'
        };
        /* eslint-disable */

        function ChevronDown(props) {
          var width = props.width,
              height = props.height,
              color = props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M6 6.694a.693.693 0 01-.492-.2l-5.3-5.3a.695.695 0 01.983-.983L6 5.017 10.814.204a.695.695 0 01.983.983l-5.305 5.3A.692.692 0 016 6.694z",
            fill: color
          }));
        }

        ChevronDown.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string,
          color: PropTypes__default["default"].string
        };
        ChevronDown.defaultProps = {
          width: '12',
          height: '6.6',
          color: '#051d33'
        };
        /* eslint-disable */

        function ChevronExpired(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M13.686 10.078L8.749 1.002a2.047 2.047 0 00-3.521 0L.291 10.078a2.046 2.046 0 001.76 3.093h9.874a2.047 2.047 0 001.761-3.093zm-6.7 1.455a.819.819 0 11.819-.819.82.82 0 01-.817.818zm.819-3.276a.819.819 0 11-1.638 0V4.162a.819.819 0 111.638 0z",
            fill: "#ab1212"
          }));
        }

        ChevronExpired.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ChevronExpired.defaultProps = {
          width: '13.976',
          height: '13.17'
        };
        /* eslint-disable */

        function ChevronExpiredWarning(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M13.686 10.078L8.749 1.002a2.047 2.047 0 00-3.521 0L.291 10.078a2.046 2.046 0 001.76 3.093h9.874a2.047 2.047 0 001.761-3.093zm-6.7 1.455a.819.819 0 11.819-.819.82.82 0 01-.817.818zm.819-3.276a.819.819 0 11-1.638 0V4.162a.819.819 0 111.638 0z",
            fill: "#ffc107"
          }));
        }

        ChevronExpiredWarning.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ChevronExpiredWarning.defaultProps = {
          width: '13.976',
          height: '13.17'
        };
        /* eslint-disable */

        function CheckInfo(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0-25.776h37.118v37.118H0z",
            transform: "translate(0 25.776)"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            clipPath: "url(#a)"
          }, /*#__PURE__*/React__default["default"].createElement("circle", {
            cx: "8.385",
            cy: "8.385",
            r: "8.385",
            transform: "translate(10.165 9.816)",
            fill: "none",
            stroke: "#051d33",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.037"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            style: {
              fill: '#051d33'
            },
            d: "M18.533 11.705a1.653 1.653 0 011.653 1.648 1.653 1.653 0 01-1.653 1.657 1.653 1.653 0 01-1.652-1.657 1.653 1.653 0 011.652-1.648zm2.718 12.228h-5.435V22.51h1.475v-4.637h-1.475v-1.42h4.091v6.06h1.344z"
          })));
        }

        CheckInfo.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        CheckInfo.defaultProps = {
          width: '37.118',
          height: '37.118'
        };
        /* eslint-disable */

        function CheckLeft(props) {
          var width = props.width,
              height = props.height,
              enable = props.enable,
              variant = props.variant;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0 7.793a.9.9 0 01.264-.639l6.89-6.89a.903.903 0 111.277 1.277L2.179 7.793l6.252 6.252a.903.903 0 11-1.277 1.277L.267 8.431A.9.9 0 010 7.793z",
            fill: enable ? variant === 'outline' ? '#051D33' : '#ffffff' : '#afa3a3'
          }));
        }

        CheckLeft.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        CheckLeft.defaultProps = {
          width: '8.695',
          height: '15.586',
          enable: true,
          variant: 'outline'
        };
        /* eslint-disable */

        function ChevronLock(props) {
          var width = props.width,
              height = props.height,
              color = props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("g", {
            fill: color,
            stroke: color
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M11.482 5.857h-1.339V4.518a4.018 4.018 0 00-8.036 0v1.339H.768a.268.268 0 00-.268.268v8.3A1.073 1.073 0 001.571 15.5h9.107a1.073 1.073 0 001.071-1.071v-8.3a.268.268 0 00-.268-.268m-8.84-1.339a3.482 3.482 0 016.965 0v1.339H2.643zm8.572 9.911a.537.537 0 01-.536.536H1.571a.536.536 0 01-.536-.536v-8.04h10.18z"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M6.126 8.769a.886.886 0 00-.3 1.723v2.129a.3.3 0 10.593 0v-2.129a.886.886 0 00-.3-1.723m0 1.185a.3.3 0 11.3-.3.3.3 0 01-.3.3"
          })));
        }

        ChevronLock.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string,
          color: PropTypes__default["default"].string
        };
        ChevronLock.defaultProps = {
          width: '12.25',
          height: '16',
          color: '#ffffff'
        };
        /* eslint-disable */

        function ChevronPlus(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("g", {
            transform: "translate(0 2)",
            fill: "#00677f",
            stroke: "#00677f"
          }, /*#__PURE__*/React__default["default"].createElement("circle", {
            cx: "8.5",
            cy: "8.5",
            r: "8.5",
            stroke: "none"
          }), /*#__PURE__*/React__default["default"].createElement("circle", {
            cx: "8.5",
            cy: "8.5",
            r: "8",
            fill: "none"
          })), /*#__PURE__*/React__default["default"].createElement("text", {
            transform: "translate(3 16)",
            fill: "#fff",
            fontSize: "16",
            fontFamily: "AvenirLTStd-Heavy,Avenir LT Std",
            fontWeight: "800"
          }, /*#__PURE__*/React__default["default"].createElement("tspan", {
            x: "1",
            y: "0"
          }, "+")));
        }

        ChevronPlus.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ChevronPlus.defaultProps = {
          width: '17',
          height: '19'
        };
        /* eslint-disable */

        function ChevronRight(props) {
          var width = props.width,
              height = props.height,
              enable = props.enable,
              variant = props.variant;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M8.695 7.793a.9.9 0 01-.264.639l-6.89 6.89a.903.903 0 11-1.277-1.277l6.252-6.252L.264 1.541A.903.903 0 111.541.264l6.887 6.891a.9.9 0 01.267.638z",
            fill: enable ? variant === 'outline' ? '#051D33' : '#ffffff' : '#afa3a3'
          }));
        }

        ChevronRight.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ChevronRight.defaultProps = {
          width: '8.695',
          height: '15.586',
          enable: true,
          variant: 'outline'
        };
        /* eslint-disable */

        function ChevronSearch(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            className: "a",
            d: "M0-25.4h28.919V3.519H0z",
            transform: "translate(0 25.4)"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            clipPath: "url(#a)"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            className: "a",
            style: {
              fill: '#808285'
            },
            d: "M6.023 12.517a6.828 6.828 0 0113.656 0 6.828 6.828 0 11-13.656 0M24.469 23l-5.69-5.69a7.629 7.629 0 10-13.562-4.793 7.64 7.64 0 007.632 7.631 7.594 7.594 0 004.794-1.7l5.689 5.689z"
          })));
        }

        ChevronSearch.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ChevronSearch.defaultProps = {
          width: '28.919',
          height: '28.919'
        };
        /* eslint-disable */

        function ChevronUp(props) {
          var width = props.width,
              height = props.height,
              color = props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M5.999 0a.693.693 0 01.492.2l5.3 5.3a.695.695 0 01-.983.983L5.999 1.677 1.185 6.49a.695.695 0 01-.983-.983l5.305-5.3A.692.692 0 015.999 0z",
            fill: color
          }));
        }

        ChevronUp.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ChevronUp.defaultProps = {
          width: '12',
          height: '6.695',
          color: '#051d33'
        };
        /* eslint-disable */

        function CollapseIcon(props) {
          var width = props.width,
              height = props.height,
              color = props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M5.999 0a.693.693 0 01.492.2l5.3 5.3a.695.695 0 01-.983.983L5.999 1.677 1.185 6.49a.695.695 0 01-.983-.983l5.305-5.3A.692.692 0 015.999 0z",
            fill: color
          }));
        }

        CollapseIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        CollapseIcon.defaultProps = {
          width: '12',
          height: '6.695',
          color: '#C3C3C3'
        };
        /* eslint-disable */

        function CrossIcon(props) {
          props.width;
          props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg"
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a",
            clipPathUnits: "userSpaceOnUse"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0 72h72V0H0z"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            clipPath: "url(#a)",
            transform: "matrix(.17266 0 0 -.17266 -3.59 8.842)"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M37.956 36.001l12.91 12.908a1.175 1.175 0 010 1.662l-.297.295a1.175 1.175 0 01-1.662 0L36 37.959 23.091 50.866a1.175 1.175 0 01-1.662 0l-.297-.295a1.175 1.175 0 010-1.662L34.04 36.001 21.132 23.092a1.175 1.175 0 010-1.662l.297-.295a1.175 1.175 0 011.662 0L36 34.043l12.908-12.908a1.175 1.175 0 011.662 0l.297.295a1.175 1.175 0 010 1.662z",
            fill: "#ef413d"
          })));
        }

        CrossIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        CrossIcon.defaultProps = {
          width: '25',
          height: '25'
        };
        /* eslint-disable */

        function ErrorIcon(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null), /*#__PURE__*/React__default["default"].createElement("circle", {
            cx: "27",
            cy: "27",
            r: "27",
            fill: "#ab1212"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            style: {
              fill: '#fff',
              stroke: '#fff',
              strokeLinecap: 'round',
              strokeWidth: '2px'
            },
            d: "M15.5 15.5l23 23M15.5 38.5l23-23"
          }));
        }

        ErrorIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ErrorIcon.defaultProps = {
          width: '60',
          height: '60'
        };
        /* eslint-disable */

        function ExistingMerchantIcon(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0-38.1h82.173v82.173H0z",
            transform: "translate(0 38.1)"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            "clip-path": "url(#a)"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M53.261 56.36v-7.516a.761.761 0 00-1.522 0v5.326c-1.469 0-3.043-2.679-3.043-4.565V41.83c6.674 2.5 9.13 8.014 9.13 12.34 0 1.109-1.576 1.859-4.565 2.19m-12.929 2.375c-4.892 0-10.254-.624-11.419-1.815v-1.229c3.072 0 4.565-1.991 4.565-6.087h13.7c0 2.452 1.917 6.087 4.565 6.087v1.017c-.026.027-.06.044-.081.076-.915 1.34-6.512 1.95-11.326 1.95M22.821 54.17c0-4.326 2.456-9.839 9.13-12.337v7.771c0 4.212-1.571 4.565-3.043 4.565v-5.325a.761.761 0 00-.761-.761.761.761 0 00-.761.761v7.532c-3.018-.313-4.565-1.05-4.565-2.206m12.922-8.048a.755.755 0 00.583.489.746.746 0 00.717-.259l3.292-3.941 3.409 3.95a.759.759 0 00.576.264.789.789 0 00.145-.014.763.763 0 00.575-.5l1.666-4.9c.158.04.313.083.467.126v6.745h-13.7v-6.741c.162-.046.326-.089.492-.132zm-.422-6.871l3.838 2.193-2.438 2.915-1.66-4.6zm5-.3a5.643 5.643 0 003.837-1.742 5.724 5.724 0 00.161.871l-3.998 2.279-3.982-2.278a5.869 5.869 0 00.155-.87 5.642 5.642 0 003.827 1.741m-5.734-7.524a4.113 4.113 0 01-1.109-2.367c0-1.3.236-1.522.761-1.522a11.014 11.014 0 007.421-3.254c.747 1.268 2.306 3.254 4.752 3.254.526 0 .761.22.761 1.522a4.1 4.1 0 01-1.107 2.365.762.762 0 00-.369.425c-1.186 3.337-3.343 5.58-5.376 5.58s-4.181-2.243-5.365-5.58a.762.762 0 00-.369-.423m5.734-12.258c5.2 0 6.491 4.13 6.773 6.944a2.582 2.582 0 00-.686-.1c-2.485 0-3.846-3.294-3.859-3.327a.761.761 0 00-.6-.468.755.755 0 00-.7.276c-.027.036-2.863 3.519-7.014 3.519a2.572 2.572 0 00-.686.1c.286-2.817 1.582-6.944 6.772-6.944m5.014 20.082l.256.515-1.563 4.593-2.522-2.922zm1.825.507a.741.741 0 00-.065-.384l-.755-1.522a.636.636 0 00-.606-.4 3.96 3.96 0 01-.082-.78v-1.291a14.194 14.194 0 001.405-2.82 5.54 5.54 0 001.638-3.5 5.694 5.694 0 00-.112-1.147.744.744 0 00.112-.374c0-6.195-3.129-9.891-8.37-9.891s-8.37 3.7-8.37 9.891a.744.744 0 00.112.374 5.694 5.694 0 00-.112 1.147 5.541 5.541 0 001.639 3.5 14.152 14.152 0 001.4 2.82v1.288a4.119 4.119 0 01-.078.78.821.821 0 00-.143.014.762.762 0 00-.46.388l-.761 1.522a.749.749 0 00-.065.39c-8.966 2.301-12.183 9.133-12.183 14.406 0 3.125 4.551 3.63 6.481 3.779 2.055 2.075 9.384 2.308 12.547 2.308 3.1 0 10.285-.233 12.328-2.308 1.983-.152 6.687-.664 6.687-3.779 0-5.267-3.218-12.111-12.188-14.41",
            fill: "#5fc5bf"
          })));
        }

        ExistingMerchantIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ExistingMerchantIcon.defaultProps = {
          width: '150',
          height: '150'
        };
        /* eslint-disable */

        function ExpandIcon(props) {
          var width = props.width,
              height = props.height,
              color = props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M6 6.694a.693.693 0 01-.492-.2l-5.3-5.3a.695.695 0 01.983-.983L6 5.017 10.814.204a.695.695 0 01.983.983l-5.305 5.3A.692.692 0 016 6.694z",
            fill: color
          }));
        }

        ExpandIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ExpandIcon.defaultProps = {
          width: '12',
          height: '6.695',
          color: '#C3C3C3'
        };
        /* eslint-disable */

        function FilterIcon(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M5.549 10.737a4.72 4.72 0 01-1.186-3.435c0-1.816-.358-2.522-2.182-4.3A10.932 10.932 0 01-.001.437c0-.239 2.7-.435 6-.435s6 .2 6 .435a10.933 10.933 0 01-2.182 2.565C7.732 5.039 7.632 5.276 7.632 8.565c0 1.889-.2 3.435-.45 3.435a4.427 4.427 0 01-1.636-1.262z",
            fill: "#fff"
          }));
        }

        FilterIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        FilterIcon.defaultProps = {
          width: '12',
          height: '12'
        };
        /* eslint-disable */

        function InstallationIcon(props) {
          var width = props.width,
              height = props.height;
          props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0-38.1h70.63v70.63H0z",
            transform: "translate(0 38.1)"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            "clip-path": "url(#a)"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M54.086 22.663a6.484 6.484 0 00-1.776-2.587c-.8-.8-3.237-3.237-5.549-.925l-8.325 8.323a.654.654 0 00-.175.608 2.484 2.484 0 01-.75 2.167 2.479 2.479 0 01-2.184.746.646.646 0 00-.216 0 9.286 9.286 0 001.036 1.314 3.961 3.961 0 002.293-1.135 3.865 3.865 0 001.152-3.005l8.093-8.094c.833-.833 1.781-.993 3.7.925a5.416 5.416 0 011.448 2.038 1.528 1.528 0 01-.523 1.66l-8.094 8.1a3.88 3.88 0 00-3 1.156 3.964 3.964 0 00-1.137 2.305l1.241 1.239a.661.661 0 00.069-.443 2.487 2.487 0 01.746-2.184 2.494 2.494 0 012.157-.752.655.655 0 00.619-.173l8.323-8.321a2.831 2.831 0 00.851-2.962M24.101 49.209l-.925-.925 1.849-1.85.923.926zm2.774-2.774l-.927-.925 4.756-4.754-.925-.925-7.99 7.991a.653.653 0 000 .925l1.85 1.849a.654.654 0 00.925 0l7.99-7.99-.925-.925zM44.888 46.155a1.31 1.31 0 00-1.849 0 1.3 1.3 0 00-.379.924 1.3 1.3 0 00.383.925 1.3 1.3 0 00.917.384 1.3 1.3 0 00.925-.384 1.309 1.309 0 000-1.849",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M46.74 49.856a2.619 2.619 0 01-3.7 0L31.016 37.832a11.958 11.958 0 00-5.3-3.053 12.539 12.539 0 003.452-2.5 12.524 12.524 0 002.494-3.447 11.976 11.976 0 003.054 5.3L46.74 46.156a2.617 2.617 0 010 3.7M15.387 25.902l3.144 3.144a2.865 2.865 0 002.891.528 7.307 7.307 0 003.121-1.915 7.289 7.289 0 001.915-3.121 2.866 2.866 0 00-.528-2.891l-3.144-3.144c1.653-.683 4.622.923 6.844 3.144a5.13 5.13 0 011.554 3.447c0 .118-.009.316 0 .576-.008.152-.016.3-.037.458a9.411 9.411 0 01-2.9 5.231 9.1 9.1 0 01-5.594 2.943c-.458-.015-.755 0-.8 0h-.005a5.167 5.167 0 01-3.314-1.562c-2.221-2.221-3.828-5.193-3.144-6.843m20.25 7.311a11.37 11.37 0 01-3.146-7.563c.008-.179 0-.356 0-.532v-.053a.4.4 0 00-.005-.041 6.385 6.385 0 00-1.935-4.3c-2.9-2.9-7.026-5-9.249-2.775a.655.655 0 00-.192.462.655.655 0 00.192.462l3.7 3.7a1.674 1.674 0 01.192 1.621 6.081 6.081 0 01-1.581 2.543c-1.634 1.637-3.5 2.046-4.16 1.389l-3.7-3.7a.655.655 0 00-.925 0c-2.224 2.224-.121 6.353 2.775 9.249a6.386 6.386 0 004.33 1.94h.016c.089 0 .177.012.267.012s.164-.014.246-.016a11.4 11.4 0 017.627 3.15l12.024 12.025a3.924 3.924 0 005.548-5.549z",
            fill: "#6DC7BE"
          })));
        }

        InstallationIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        InstallationIcon.defaultProps = {
          width: '150',
          height: '150'
        };
        /* eslint-disable */

        function LogoMonerisMerchant(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 141.4 46.6",
            fill: "#fff",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            className: "logo",
            d: "M121.8 8.6c-.8-.7-1.7-1.3-2.7-1.7-1.1-.4-2.2-.7-3.3-.9-1.2-.2-2.4-.2-3.6-.1-1.3.1-2.6.4-3.8.9-1 .4-2 .9-2.9 1.5-1 .6-1.9 1.3-2.8 2.1-.9.8-1.7 1.8-2.5 2.8-.8 1.1-1.5 2.3-2 3.6-.6 1.4-1 2.8-1.3 4.2-.3 1.5-.4 3.1-.3 4.6.1 1.6.4 3.2.9 4.8.5 1.6 1.3 3.1 2.2 4.6 2.5 3.7 5.8 6.4 9.5 8 3.6 1.5 7.3 1.9 10.9 1.3 3.3-.5 6.3-1.9 8.8-4 2.2-1.8 4.1-4.1 5.3-6.8.1-.2.1-.4.1-.5v-.6c0-.2-.1-.4-.2-.6-.1-.2-.2-.4-.3-.5-.1-.1-.3-.3-.4-.3-.1-.1-.3-.1-.4-.1-.1 0-.3 0-.4.1l-.3.3c-1.2 2.2-2.8 4-4.8 5.4-2.1 1.5-4.7 2.5-7.4 2.8-2.9.3-5.9-.2-8.8-1.5-3-1.3-5.6-3.5-7.6-6.4-.8-1.1-1.4-2.3-1.8-3.5-.4-1.2-.7-2.4-.9-3.7-.1-1.2-.1-2.4 0-3.6.1-1.2.4-2.3.8-3.4.3-.7.6-1.4.9-2 .3-.6.7-1.2 1.1-1.8.4-.5.8-1 1.3-1.5.4-.5.9-.9 1.4-1.3.3-.2.5-.4.8-.6.3-.2.5-.4.8-.5.3-.2.5-.3.8-.5.3-.1.5-.3.8-.4.3-.1.6-.3.9-.4l.9-.3c.3-.1.6-.1.9-.2.3 0 .6-.1.9-.1-.3.1-.5.2-.8.3-.3.1-.5.2-.8.4-.3.1-.5.3-.8.5-.2.2-.5.4-.7.6-.2.1-.3.3-.5.4-.2.2-.3.3-.4.5-.1.2-.3.3-.4.5-.1.2-.3.4-.4.6-1 1.5-1.6 3.3-1.8 5.2-.2 2 0 4 .7 6 .7 2.1 1.9 4 3.4 5.6 1.6 1.6 3.5 2.8 5.6 3.5 1.2.4 2.5.6 3.7.7 1.2.1 2.4 0 3.5-.2s2.1-.6 3-1c.9-.4 1.8-1 2.5-1.7.7-.6 1.4-1.3 1.9-2.1.5-.7 1-1.5 1.3-2.3.3-.8.6-1.6.8-2.4.2-.8.3-1.7.3-2.5.1-2-.2-4-.8-5.9-.5-1.7-1.3-3.4-2.2-4.9-.9-1.5-2-2.8-3.3-4.1-1.3-1.2-2.7-2.3-4.4-3.3.4-.2.3-.2.2-.3h-.3c-.1 0-.2 0-.2.1-.1 0-.1.1-.2.2v.3c0 .1 0 .2.1.3.1.1.1.2.2.3.1.1.2.2.3.2 1.5.8 2.8 1.8 3.9 2.9 1.1 1.1 2.1 2.4 2.9 3.7.8 1.4 1.5 2.9 1.9 4.4.4 1.6.6 3.4.5 5.2l-.3 2.1c-.2.7-.4 1.4-.7 2-.3.7-.7 1.3-1.2 1.8-.5.6-1 1.1-1.7 1.6s-1.4.9-2.1 1.2c-.8.3-1.6.6-2.5.7-.9.1-1.8.1-2.8 0-1-.1-2-.3-2.9-.7-.4-.1-.8-.3-1.1-.5-.4-.2-.7-.4-1.1-.6-.3-.2-.7-.5-1-.7-.3-.3-.6-.5-.9-.8.6.3 1.2.5 1.9.7.6.2 1.3.3 1.9.4.6.1 1.3.1 1.9 0 .6 0 1.2-.1 1.8-.3.9-.2 1.7-.6 2.4-1s1.4-.8 2-1.4c.6-.5 1.1-1.1 1.5-1.7.4-.6.8-1.2 1.1-1.9.3-.7.5-1.3.6-2 .1-.7.2-1.3.2-2s0-1.3-.1-2c-.1-.6-.3-1.3-.5-1.9-.5-1.6-1.3-3-2.2-4.2-.9-1.2-2-2.4-3.2-3.3-1.2-1-2.6-1.8-4.1-2.5-1.5-.7-3.2-1.2-5-1.4-2.4-.3-4.7-.3-7.1 0-2.6.4-5.1 1.2-7.5 2.4-2.7 1.4-5.2 3.3-7.3 5.7-2.4 2.7-4.2 6.1-5.1 9.9-.1.3 0 .5 0 .7.1.2.2.4.5.6.2.2.5.3.8.3.3.1.7.1 1 0 .4 0 .7-.1 1.1-.3.3-.1.6-.3.9-.5.3-.2.5-.4.6-.6.2-.2.3-.5.3-.7.5-3.2 1.8-6 3.6-8.3 1.6-2.1 3.6-3.8 5.8-5.1 2-1.2 4.1-1.9 6.3-2.4 2-.4 4.1-.5 6.2-.2 1.6.2 3 .6 4.3 1.2 1.3.6 2.5 1.3 3.6 2.1s2 1.8 2.8 2.9c.8 1.1 1.4 2.4 1.9 3.7.2.5.3 1.1.4 1.6.1.5.1 1.1.1 1.6s-.1 1.1-.2 1.6-.3 1.1-.6 1.6l-.9 1.5c-.4.5-.8.9-1.3 1.2-.5.4-1 .7-1.6 1-.6.3-1.2.5-1.9.6-.5.1-1.1.2-1.7.2-.6 0-1.1-.1-1.7-.2-.6-.1-1.1-.3-1.7-.6-.6-.3-1.1-.6-1.6-1s-1-.8-1.4-1.3c-.4-.5-.8-1-1.1-1.5-.3-.5-.5-1.1-.7-1.6-.2-.6-.2-1.4-.2-2 0-.3.2-1 .3-1.3.1-.3.2-.5.3-.8.1-.2.2-.5.4-.7.5-.9 1.2-1.7 2-2.2.8-.5 1.6-.9 2.5-1.1.9-.2 1.8-.2 2.7-.1.8.1 1.6.4 2.3.8.1.1.2.1.4.1h.3c.1 0 .2-.1.3-.1.1-.1.2-.1.2-.2s.1-.2.1-.3V9c0-.1-.1-.2-.2-.3-.1.1-.2 0-.3-.1zM18.5 43.1l-1.1-7.6c-.2-1.5-.4-2.7-.5-3.8-.2 1-.5 2.1-.9 3.4l-2.5 8h-3L8 35.8c-.4-1.3-.8-2.7-1-4-.1 1.4-.3 2.7-.4 4l-.9 7.3H2.5l2.4-15.9h3.6l2.7 8.2c.4 1.1.7 2.2.9 3.3.2-1.2.5-2.1.9-3.3l2.7-8.2h3.6l2.5 15.9h-3.3zM32.1 37.2c0 2.4-1.1 3.6-2.6 3.6-1.7 0-2.6-1.2-2.6-3.6 0-2.4 1.3-3.4 2.7-3.4 1.7 0 2.5 1.2 2.5 3.4zm3.1-.1c0-4-2.1-5.9-5.5-5.9-3.6 0-6 2.6-6 6.3 0 4.2 2.1 5.9 5.5 5.9 3.5 0 6-2.7 6-6.3zM59 35.7h-4.3c.2-1.4 1-2.3 2.3-2.3 1.3 0 2.1.9 2 2.3zm3 .7c0-2.9-1.5-5.2-4.9-5.2-3.5 0-5.5 2.6-5.5 6.2 0 4.1 2.1 6 5.8 6 1.5 0 2.9-.3 4.2-.8l-.3-2.3c-1 .5-2.3.7-3.4.7-2.2 0-3.2-1.1-3.2-3.2h7.2c.1-.5.1-1 .1-1.4zM64.5 33.6c-.2-.3-.3-.6-.3-1s.1-.7.3-1c1.4-.2 3.1-.2 4.6-.2 0 .6-.1 1.6-.2 2.4.6-1.5 1.7-2.8 3.7-2.6l-.1 3c-2.2-.4-3.2 1-3.2 4.2v4.8h-3v-9.4c-.5-.1-1.2-.2-1.8-.2zM80 28.1c0-1-.8-1.8-1.9-1.8-1 0-1.9.8-1.9 1.8s.8 1.8 1.9 1.8c1 .1 1.9-.8 1.9-1.8zM85.5 43.4c-.8 0-1.7-.1-2.4-.2l.1-2.5c.7.2 1.6.4 2.5.4 1.2 0 1.9-.5 1.9-1.2 0-2.1-4.7-.9-4.7-4.9 0-2 1.7-3.7 5-3.7.7 0 1.4.1 2.1.2l-.1 2.4c-.7-.2-1.4-.3-2.2-.3-1.2 0-1.7.5-1.7 1.2 0 1.9 4.8 1.1 4.8 4.8-.1 2.2-2.1 3.8-5.3 3.8zM41.4 31.4c0 .6 0 1.5-.2 2.1.7-1.4 2.1-2.4 4-2.4 2.6 0 3.5 1.7 3.5 3.7V43h-3v-7.5c0-1.2-.3-2-1.4-2-1.5 0-2.7 1.7-2.7 3.8v5.6h-3v-9.4c-.5-.1-1.1-.2-1.8-.2-.2-.3-.3-.6-.3-1s.1-.7.3-1c1.4.2 3.1.1 4.6.1zM79.6 31.4c-1.5 0-3.3 0-4.7.2-.2.3-.3.6-.3 1s.1.7.3 1c.6.1 1.3.1 1.8.2v9.4h3V31.4z"
          }), /*#__PURE__*/React__default["default"].createElement("g", null, /*#__PURE__*/React__default["default"].createElement("path", {
            className: "logo",
            d: "M138.8 3.3v-1l-.3.9-.4 1.1h-.3l-.3-1.1c-.1-.3-.2-.7-.2-1v1.1l-.1 1h-.4l.2-2.5h.6l.3 1c.1.3.2.6.2.9.1-.3.2-.6.2-.9l.3-1h.6l.1 2.5h-.4l-.1-1zM139.8 1.9c.2 0 .5-.1.7-.1.5 0 .8.1 1 .3.2.2.4.5.4.9s-.2.8-.4 1c-.2.2-.6.3-1.1.3h-.6V1.9zm.4 2.1h.3c.6 0 .9-.3.9-.9 0-.5-.3-.9-.9-.9h-.3V4z"
          })), /*#__PURE__*/React__default["default"].createElement("path", {
            className: "logo",
            d: "M134.5 3.1c0 1-.7 1.7-1.7 1.7s-1.7-.7-1.7-1.7c0-.9.8-1.7 1.7-1.7 1 0 1.7.7 1.7 1.7zm-3 0c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.5-1.3-1.3-1.3-.7-.1-1.3.5-1.3 1.3zm1.1.8h-.4V2.3c.2 0 .4-.1.6-.1.3 0 .5.1.6.1.1.1.2.2.2.4s-.1.3-.3.4c.2.1.3.2.3.4.1.3.1.4.1.4h-.4c-.1-.1-.1-.2-.1-.4s-.1-.3-.3-.3h-.2v.7zm0-.9h.2c.2 0 .4-.1.4-.2 0-.2-.1-.3-.4-.3h-.2V3z"
          }), /*#__PURE__*/React__default["default"].createElement("g", null, /*#__PURE__*/React__default["default"].createElement("path", {
            className: "logo",
            d: "M136.4 1.6l-1.2 3h-.5l1.2-3h.5z"
          })));
        }

        LogoMonerisMerchant.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        LogoMonerisMerchant.defaultProps = {
          width: '48',
          height: '48'
        };
        /* eslint-disable */

        function NewMerchantIcon(props) {
          var width = props.width,
              height = props.height;
          props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0-38.1h82.173v82.173H0z",
            transform: "translate(0 38.1)"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            "clip-path": "url(#a)"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M64.297 48.431h-5.6v-5.628a.759.759 0 00-.757-.761.759.759 0 00-.76.761v5.63h-5.6a.758.758 0 00-.757.761.758.758 0 00.757.761h5.6v5.63a.758.758 0 101.515 0v-5.633h5.6a.761.761 0 000-1.522M27.734 55.754h-.757a.761.761 0 010-1.522h.757c1.465 0 3.027-.353 3.027-4.565v-9.23a.76.76 0 01.761-.761.759.759 0 01.757.761v9.23c0 4.1-1.485 6.087-4.542 6.087M48.173 55.754h-.757c-2.635 0-4.542-3.635-4.542-6.087v-9.23a.758.758 0 01.757-.761.759.759 0 01.757.761v9.23c0 1.887 1.567 4.564 3.028 4.564h.757a.761.761 0 010 1.522",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M43.629 49.667h-12.11a.759.759 0 01-.757-.761.759.759 0 01.757-.761h12.11a.759.759 0 01.76.761.759.759 0 01-.76.761M31.867 31.491a.76.76 0 01.367.424c1.182 3.334 3.333 5.58 5.347 5.58s4.165-2.244 5.343-5.58a.761.761 0 01.368-.425 4.117 4.117 0 001.1-2.365c0-1.3-.234-1.522-.757-1.522-2.434 0-3.985-1.987-4.728-3.256a10.934 10.934 0 01-7.382 3.257c-.524 0-.758.219-.758 1.522a4.125 4.125 0 001.1 2.365m5.71 7.526c-2.652 0-5.265-2.5-6.7-6.391a5.546 5.546 0 01-1.631-3.5c0-2.021.764-3.043 2.271-3.043 4.131 0 6.952-3.484 6.98-3.519a.746.746 0 01.7-.278.758.758 0 01.593.469c.013.033 1.367 3.327 3.84 3.327 1.507 0 2.27 1.023 2.27 3.043a5.549 5.549 0 01-1.63 3.5c-1.433 3.891-4.046 6.391-6.7 6.391",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M33.096 40.878a.752.752 0 01-.623-.329.762.762 0 01.193-1.058 3.174 3.174 0 001.124-2.536.758.758 0 01.756-.761.758.758 0 01.757.761 4.688 4.688 0 01-1.778 3.788.751.751 0 01-.429.135M42.114 40.877a.748.748 0 01-.427-.134 4.693 4.693 0 01-1.777-3.788.759.759 0 01.757-.761.759.759 0 01.757.761 3.176 3.176 0 001.13 2.541.765.765 0 01.178 1.057.75.75 0 01-.619.324",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M52.265 47.163a.754.754 0 01-.65-.372c-1.88-3.178-5.116-5.168-9.623-5.912a.76.76 0 01-.624-.874.75.75 0 01.87-.626c4.968.82 8.561 3.054 10.677 6.634a.762.762 0 01-.263 1.042.746.746 0 01-.387.107M37.581 60.319c-2.716 0-9.026-.233-10.984-2.308-1.921-.148-6.435-.657-6.435-3.778 0-3.839 1.249-12.972 12.811-14.867a.757.757 0 01.87.628.764.764 0 01-.625.875c-10.041 1.645-11.54 9.078-11.54 13.364 0 1.258 1.8 2.028 5.353 2.285a.758.758 0 01.571.331c.91 1.339 5.81 1.949 9.979 1.949s9.057-.61 9.967-1.949a.754.754 0 011.052-.2.762.762 0 01.2 1.058c-1.6 2.359-8.378 2.614-11.217 2.614",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M26.976 58.037a.758.758 0 01-.757-.761v-9.891a.758.758 0 01.757-.761.759.759 0 01.757.761v9.891a.759.759 0 01-.757.761M48.174 58.037a.758.758 0 01-.757-.761v-9.891a.758.758 0 01.757-.761.759.759 0 01.757.761v9.891a.759.759 0 01-.757.761M48.181 42.82a.758.758 0 01-.7-.479 43.83 43.83 0 01-3.087-14.739c0-2.517-.663-8.37-6.813-8.37s-6.814 5.853-6.814 8.37a43.83 43.83 0 01-3.082 14.739.754.754 0 01-.984.425.763.763 0 01-.422-.989 43.132 43.132 0 002.974-14.175c0-6.194 3.113-9.891 8.328-9.891s8.324 3.697 8.324 9.891a43.109 43.109 0 002.974 14.174.762.762 0 01-.422.989.736.736 0 01-.281.054",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M37.576 46.626a.711.711 0 01-.126-.011 6.35 6.35 0 01-5.175-6.5.759.759 0 01.758-.759.759.759 0 01.757.761 4.821 4.821 0 003.91 5 .761.761 0 01-.124 1.509",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M37.574 46.626a.761.761 0 01-.125-1.513 4.857 4.857 0 003.912-5 .759.759 0 01.757-.761.759.759 0 01.757.761 6.35 6.35 0 01-5.175 6.5.711.711 0 01-.126.013M47.892 57.73c1.972-.153 6.653-.664 6.653-3.779a13.465 13.465 0 00-.17-2.108.756.756 0 00-.868-.629.758.758 0 00-.627.871 11.951 11.951 0 01.152 1.867c0 1.11-1.569 1.859-4.54 2.189",
            fill: "#6DC7BE"
          })));
        }

        NewMerchantIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        NewMerchantIcon.defaultProps = {
          width: '150',
          height: '150'
        };

        function PasswordShowIcon(props) {
          var active = props.active;
          var color = active ? '#051d33' : '#c3c3c3';
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "10",
            viewBox: "0 0 24.41 12.608"
          }, /*#__PURE__*/React__default["default"].createElement("g", {
            transform: "translate(-69.535 -142.91)",
            stroke: color
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M70.55 150.484c4.413-9.022 18.175-8.47 22.38.037",
            fill: "none",
            strokeWidth: "2.018",
            strokeLinecap: "round",
            strokeLinejoin: "bevel"
          }), /*#__PURE__*/React__default["default"].createElement("ellipse", {
            cx: "81.63",
            cy: "150.598",
            rx: "4.364",
            ry: "4.458",
            fill: color,
            strokeWidth: ".922"
          })));
        }

        PasswordShowIcon.propTypes = {
          active: PropTypes__default["default"].bool
        };
        PasswordShowIcon.defaultProps = {
          active: true
        };
        /* eslint-disable */

        function PlusIcon(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("g", {
            transform: "translate(0 2)",
            fill: "#fff",
            stroke: "#051D33"
          }, /*#__PURE__*/React__default["default"].createElement("circle", {
            cx: "9.5",
            cy: "9.5",
            r: "9.5",
            stroke: "none"
          }), /*#__PURE__*/React__default["default"].createElement("circle", {
            cx: "9.5",
            cy: "9.5",
            r: "9",
            fill: "none"
          })), /*#__PURE__*/React__default["default"].createElement("text", {
            transform: "translate(4 17)",
            fill: "#051D33",
            fontSize: "18",
            fontFamily: "AvenirLTStd-Heavy,Avenir LT Std",
            fontWeight: "800"
          }, /*#__PURE__*/React__default["default"].createElement("tspan", {
            x: "0",
            y: "0"
          }, "+")));
        }

        PlusIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        PlusIcon.defaultProps = {
          width: "19",
          height: "22"
        };
        /* eslint-disable */

        function ProcessingIcon(props) {
          var width = props.width,
              height = props.height;
          props.color;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
            id: "a"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            d: "M0-38.1h75.212v75.211H0z",
            transform: "translate(0 38.1)"
          }))), /*#__PURE__*/React__default["default"].createElement("g", {
            "clip-path": "url(#a)"
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M26.817 29.585h14.512v-9.312H26.817zm15.171 1.33H26.157a.66.66 0 01-.658-.664V19.607a.661.661 0 01.658-.665h15.831a.662.662 0 01.66.665v10.64a.662.662 0 01-.66.664M38.691 34.911h1.32v-1.33h-1.32zm1.979 1.331h-2.64a.664.664 0 01-.659-.666v-2.665a.662.662 0 01.659-.664h2.64a.661.661 0 01.659.664v2.661a.662.662 0 01-.659.666M33.412 34.911h1.324v-1.33h-1.32zm1.981 1.331h-2.639a.663.663 0 01-.659-.666v-2.665a.661.661 0 01.659-.664h2.639a.661.661 0 01.659.664v2.661a.662.662 0 01-.659.666M28.132 34.911h1.319v-1.33h-1.319zm1.978 1.331h-2.634a.663.663 0 01-.659-.666v-2.665a.661.661 0 01.659-.664h2.638a.661.661 0 01.66.664v2.661a.662.662 0 01-.66.666M38.691 40.228h1.32v-1.33h-1.32zm1.979 1.33h-2.64a.662.662 0 01-.659-.665v-2.656a.663.663 0 01.659-.665h2.64a.662.662 0 01.659.665v2.661a.661.661 0 01-.659.665M33.412 40.228h1.324v-1.33h-1.32zm1.981 1.33h-2.639a.662.662 0 01-.659-.665v-2.656a.662.662 0 01.659-.665h2.639a.662.662 0 01.659.665v2.661a.661.661 0 01-.659.665M38.691 45.549h1.32v-1.33h-1.32zm1.979 1.332h-2.64a.663.663 0 01-.659-.666v-2.66a.663.663 0 01.659-.665h2.64a.662.662 0 01.659.665v2.66a.662.662 0 01-.659.666M33.412 45.549h1.324v-1.33h-1.32zm1.981 1.332h-2.639a.662.662 0 01-.659-.666v-2.66a.662.662 0 01.659-.665h2.639a.662.662 0 01.659.665v2.66a.662.662 0 01-.659.666M28.132 40.228h1.319v-1.33h-1.319zm1.978 1.33h-2.634a.662.662 0 01-.659-.665v-2.656a.662.662 0 01.659-.665h2.638a.662.662 0 01.66.665v2.661a.661.661 0 01-.66.665M28.132 45.549h1.319v-1.33h-1.319zm1.978 1.332h-2.634a.662.662 0 01-.659-.666v-2.66a.662.662 0 01.659-.665h2.638a.662.662 0 01.66.665v2.66a.662.662 0 01-.66.666",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M44.998 48.754a2.64 2.64 0 01-2.35 1.453H25.499a2.653 2.653 0 01-2.64-2.66v-28.6a2.653 2.653 0 012.64-2.662H40.01a.663.663 0 01.659.666.663.663 0 01-.659.665H25.499a1.326 1.326 0 00-1.32 1.331v28.6a1.327 1.327 0 001.32 1.33h17.149a1.32 1.32 0 001.17-.715l.109-.194z",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M45.286 33.244v-14.3a2.653 2.653 0 00-2.638-2.663h-3.3a.661.661 0 00-.66.666.661.661 0 00.66.664h3.3a1.327 1.327 0 011.32 1.332v13.65a2.2 2.2 0 011.318.65M39.746 56.674H28.28a1.93 1.93 0 01-1.92-1.939v-5.061a.694.694 0 01.692-.7.7.7 0 01.693.7v5.061a.538.538 0 00.536.54h11.465a.539.539 0 00.537-.54v-5.061a.694.694 0 01.692-.7.694.694 0 01.692.7v5.061a1.931 1.931 0 01-1.921 1.939",
            fill: "#6DC7BE"
          }), /*#__PURE__*/React__default["default"].createElement("path", {
            "class": "b",
            d: "M31.967 53.624a.694.694 0 01-.692-.7v-2.476a.694.694 0 01.692-.7.7.7 0 01.692.7v2.478a.7.7 0 01-.692.7M56.277 44.914a2.48 2.48 0 01-1.33 3.216l-3.73 1.543a2.39 2.39 0 01-2.371-.315l-5.571-4.116a.613.613 0 01-.047-.846.6.6 0 01.412-.2.71.71 0 01.454.144c.013.029.041.016.053.045l2.106 1.524c.01.029.039.017.052.046l.039.017a.111.111 0 00.068 0l.04.017c.029-.013.039.016.068.006s.04.016.069 0 .028-.012.068 0c.029-.012.029-.012.068.006a.514.514 0 00.057-.023l.056-.024.029-.011.056-.023c.029-.013.029-.013.046-.052.029-.013.029-.013.044-.053.028-.011.017-.04.047-.052a.028.028 0 00.015-.039c.028-.013.017-.041.045-.052l.016-.041.017-.041c-.012-.029.017-.038 0-.068a.109.109 0 00.006-.07c-.012-.027.016-.04 0-.068s-.012-.029 0-.068c-.011-.029-.011-.029.006-.07l-.023-.057-.013-.047-4.1-10.051a.619.619 0 01.332-.8.611.611 0 01.8.335l2.556 6.264a.609.609 0 00.8.336.621.621 0 00.333-.8l-.7-1.708a.618.618 0 01.334-.8.61.61 0 01.8.334l.922 2.27a.609.609 0 00.8.336.619.619 0 00.334-.8l-.701-1.716a.62.62 0 01.333-.8.611.611 0 01.8.336l.925 2.278a.609.609 0 00.8.334.619.619 0 00.333-.8l-.467-1.14a.619.619 0 01.331-.808.613.613 0 01.8.336l1.854 4.558.7 1.708zm-4.046-8.307a2.369 2.369 0 00-.575.371 1.832 1.832 0 00-2.149-.574 1.666 1.666 0 00-.725.567 1.848 1.848 0 00-1.765-.2 1.387 1.387 0 00-.518.348l-1.207-2.96a1.833 1.833 0 00-2.39-1.007 1.859 1.859 0 00-1 2.412l3.3 8.086-.336-.26a1.743 1.743 0 00-1.3-.428 1.872 1.872 0 00-1.264.623 1.888 1.888 0 00.178 2.622.031.031 0 00.039.018l5.583 4.142a3.662 3.662 0 003.582.446l3.727-1.545a3.715 3.715 0 002-4.821l-.233-.568-.7-1.71-1.861-4.556a1.83 1.83 0 00-2.386-1.006",
            fill: "#6DC7BE"
          })));
        }

        ProcessingIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        ProcessingIcon.defaultProps = {
          width: '150',
          height: '150'
        };
        /* eslint-disable */

        function SortIcon(props) {
          var width = props.width,
              height = props.height;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height
          }, /*#__PURE__*/React__default["default"].createElement("path", {
            style: {
              fill: '#00677f'
            },
            d: "M.575 5.303a.335.335 0 00-.238-.1.335.335 0 00-.235.1.336.336 0 000 .477l2.7 2.7a.333.333 0 00.109.073.336.336 0 00.258 0 .329.329 0 00.109-.073l2.7-2.7a.34.34 0 00-.484-.477L3.372 7.424 3.44.337a.337.337 0 00-.338-.336.336.336 0 00-.337.337l-.063 7.086zM11.494 3.274a.335.335 0 00.238.1.335.335 0 00.235-.1.336.336 0 000-.477l-2.7-2.7a.333.333 0 00-.109-.073.336.336 0 00-.258 0 .329.329 0 00-.109.073l-2.7 2.7a.34.34 0 00.484.477l2.122-2.121-.068 7.087a.337.337 0 00.338.336.336.336 0 00.337-.337l.063-7.086z"
          }));
        }

        SortIcon.propTypes = {
          width: PropTypes__default["default"].string,
          heigth: PropTypes__default["default"].string
        };
        SortIcon.defaultProps = {
          width: '12.069',
          height: '8.575'
        };
        /*eslint-disable*/

        function SwirlIcon(props) {
          //   const { width, height } = props;
          return /*#__PURE__*/React__default["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 550 570"
          }, /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("linearGradient", {
            id: "a",
            x1: "0%",
            y1: "100%",
            x2: "100%",
            y2: "0%"
          }, /*#__PURE__*/React__default["default"].createElement("stop", {
            offset: "0%",
            "stop-color": "#eee",
            "stop-opacity": ".6"
          }), /*#__PURE__*/React__default["default"].createElement("stop", {
            offset: "100%",
            "stop-color": "#eee"
          }))), /*#__PURE__*/React__default["default"].createElement("path", {
            fill: "url(#a)",
            d: "M396.1 121.1c-8.7-7-17.8-13.5-28.4-17.6-11.3-4.3-22.9-7.9-34.9-9.7-12.4-1.9-25.1-2.4-37.9-1.2-13.3 1.3-26.8 4.3-40.1 9.4-10.7 4.1-20.9 9.2-30.7 15.2-10.3 6.3-20 13.6-29 22-9.5 8.7-18.3 18.6-26.1 29.5-8.2 11.4-15.4 24-21.3 37.6-6.2 14.2-10.7 29.1-13.6 44.5-2.9 16-4 32.3-3 48.6 1 16.9 4.1 33.7 9.5 50 5.5 16.7 13.1 32.7 23 47.7 25.7 38.7 60.3 66.9 99.2 83.5 37.5 16 77 20.2 114.3 14 34.4-5.7 65.7-20.1 91.9-41.4 23.6-19.1 42.5-43.4 55.9-71.5.8-1.7 1.3-3.7 1.6-5.7.2-2 .1-4.2-.2-6.3-.3-2.1-.9-4.2-1.7-6.2-.8-2-1.9-3.8-3.2-5.4-1.3-1.6-2.7-2.7-4.1-3.5-1.4-.8-2.9-1.2-4.2-1.2-1.4 0-2.7.4-4 1.2-1.2.8-2.3 2-3.2 3.6-12.4 22.9-29.4 42-49.9 56.6-22.4 15.9-48.8 26-77.1 29.1-30.3 3.3-62-1.6-92-15.3-30.9-14.1-58.6-36.8-79.8-67.5-7.9-11.5-14.2-23.7-18.9-36.5-4.6-12.6-7.6-25.5-9-38.6-1.4-12.8-1.3-25.6.3-38.2 1.5-12.2 4.4-24.2 8.7-35.8 2.7-7.4 5.8-14.4 9.4-21.1 3.5-6.5 7.4-12.7 11.6-18.5 4.1-5.7 8.6-11 13.3-16 4.6-4.8 9.5-9.3 14.7-13.4 2.6-2.1 5.3-4.1 8.1-6.1 2.7-1.9 5.5-3.7 8.3-5.4 2.8-1.7 5.6-3.3 8.5-4.8 2.9-1.5 5.7-2.9 8.7-4.2 3.3-1.4 6.6-2.7 9.9-3.8 3.3-1.1 6.6-2 9.9-2.8 3.3-.8 6.6-1.4 9.9-1.9 3.3-.5 6.5-.8 9.8-1.1-2.8 1-5.6 2.1-8.3 3.3-2.8 1.2-5.5 2.6-8.2 4.1-2.7 1.5-5.3 3.2-7.9 4.9-2.6 1.8-5.1 3.8-7.6 5.8-1.6 1.4-3.3 2.9-4.9 4.5-1.6 1.6-3.1 3.2-4.7 4.9-1.5 1.7-3 3.5-4.4 5.4-1.4 1.9-2.8 3.8-4.1 5.9-10.5 16.2-16.9 34.6-19.2 54.1-2.4 20.7 0 42.2 7.1 62.9 7.3 21.5 19.4 41.5 35.7 58.2 16.4 16.8 36.4 29.6 59 36.9 13.1 4.2 26.1 6.7 39 7.4 12.5.8 24.6 0 36.2-2.3 11.2-2.2 21.9-5.8 31.9-10.7 9.6-4.7 18.5-10.5 26.6-17.4 7.8-6.6 14.5-13.9 20.3-21.9 5.5-7.6 10.2-15.8 13.9-24.3 3.6-8.2 6.3-16.8 8.2-25.6 1.8-8.5 2.9-17.3 3.2-26.3.7-21.5-2.3-42.1-7.9-61.4-5.4-18.2-13.3-35.5-23.1-51.3-9.6-15.4-21.2-29.8-34.5-42.7C443.3 74.5 428 62.8 410.8 53c-1.1-.7-2.3-1.1-3.4-1.4-1.1-.3-2.2-.4-3.1-.3-1 .1-1.8.3-2.5.8-.7.4-1.3 1.1-1.6 1.9-.3.8-.4 1.7-.3 2.6.1.9.5 1.9 1.1 2.9.6 1 1.3 1.9 2.2 2.8.9.9 2 1.7 3.1 2.3 15.6 8.7 29.4 19.2 41.4 30.7 12 11.6 22.4 24.7 30.8 38.6 8.7 14.3 15.5 29.9 19.9 46.1 4.6 17.1 6.7 35.3 5.4 54.1-.5 7.5-1.7 14.8-3.5 21.8-1.9 7.3-4.5 14.3-7.8 20.9-3.4 6.8-7.6 13.3-12.4 19.3-5.1 6.2-10.9 11.8-17.6 16.8-6.9 5.1-14.3 9.4-22.3 12.7-8.2 3.4-16.9 5.8-26.1 7.2-9.4 1.3-19.1 1.5-29 .5-10.1-1-20.4-3.3-30.7-7-4.1-1.4-8-3.1-11.9-5-3.9-1.9-7.6-4-11.3-6.3-3.6-2.3-7.1-4.8-10.5-7.5-3.4-2.7-6.6-5.5-9.6-8.6 6.4 3.2 13 5.7 19.7 7.7 6.6 1.9 13.3 3.3 20 4 6.6.7 13.2.8 19.7.3 6.4-.5 12.7-1.6 18.9-3.2 9.2-2.4 17.7-5.8 25.6-10 7.6-4.1 14.5-8.9 20.7-14.3 6-5.3 11.3-11.2 15.9-17.5 4.4-6.2 8.2-12.8 11.2-19.9 2.9-6.8 5.1-13.8 6.6-20.8 1.4-6.9 2.2-13.8 2.2-20.8.1-6.8-.4-13.7-1.5-20.5-1.1-6.7-2.8-13.4-5-20-5.5-16.3-13.4-31.2-23-44.5-9.5-13-20.8-24.8-33.4-35-12.7-10.2-27.1-19.1-42.6-26-16-7.1-33.6-12.4-52.4-15.2-24.6-3.6-49.5-3.4-73.9.3-26.6 4-53.1 12.5-78.2 25.5-27.9 14.4-54.1 34.4-76.1 59.7-24.7 28.5-43.8 63.6-53.2 104.1-.7 2.8-.5 5.4.5 7.7.9 2.3 2.6 4.3 4.8 5.9 2.2 1.6 5 2.8 8.3 3.4 3.2.7 6.9.8 10.8.4 3.9-.4 7.7-1.4 11.2-2.8 3.5-1.4 6.6-3.1 9.4-5.2 2.7-2 5-4.3 6.8-6.8 1.7-2.4 2.8-5 3.3-7.6 5.5-33.3 19.1-62.8 37.7-87.3 16.9-22.2 37.7-40 60.5-53.3 20.7-12.1 43.2-20.4 66.1-24.8 21.2-4.1 43-4.9 64.9-2.2 16.2 2 31.5 6.3 45.5 12.3 13.6 5.9 26.2 13.5 37.3 22.4 11.1 8.9 21 19.2 29.1 30.6 8.3 11.6 15 24.7 19.4 38.8 1.7 5.5 2.9 11 3.7 16.5.8 5.6 1 11.2.7 16.7-.3 5.6-1.1 11.2-2.5 16.7-1.4 5.6-3.4 11.1-6.1 16.4-2.7 5.5-5.9 10.6-9.7 15.3-3.9 4.8-8.3 9.2-13.3 13.1-5.1 4-10.7 7.4-16.9 10.3-6.3 2.9-13.1 5.2-20.3 6.7-5.7 1.2-11.6 1.8-17.5 1.7-6-.1-12-.8-18-2.2-6-1.4-12-3.4-17.8-6.1-5.8-2.7-11.4-6.1-16.7-10.1-5.3-4-10.3-8.5-14.7-13.4-4.4-4.9-8.3-10.2-11.5-15.7-3.2-5.5-5.7-11.3-7.4-17.2-1.7-5.9-2-14.9-1.8-20.9.1-3.4 1.7-10.7 2.7-13.4 1-2.7 2.2-5.3 3.4-7.9 1.2-2.5 2.5-4.9 3.8-7.2 5.5-9.7 12.8-17.4 21.2-23.3 8-5.6 17-9.5 26.5-11.6 9.1-2 18.5-2.5 28.1-1.1 8.7 1.2 16.7 4 24.1 8 1.3.7 2.5 1.2 3.8 1.5 1.2.3 2.5.3 3.6.1 1.1-.2 2.1-.5 3-1.1.9-.6 1.6-1.3 2.1-2.3.5-.9.8-2 .9-3.1 0-1.1-.1-2.2-.5-3.4-.4-1.2-.9-2.3-1.7-3.3-1-1-2-2-3-2.9z"
          }));
        }

        SwirlIcon.propTypes = {
          width: PropTypes__default["default"].string,
          height: PropTypes__default["default"].string
        };
        SwirlIcon.defaultProps = {
          width: '576',
          height: '576'
        };
        exports.ActiveExistingMerchantIcon = ActiveExistingMerchantIcon;
        exports.CheckIcon = CheckIcon;
        exports.ChevronCancel = ChevronCancel;
        exports.ChevronClose = ChevronClose;
        exports.ChevronCopyIcon = ChevronCopyIcon;
        exports.ChevronDown = ChevronDown;
        exports.ChevronExpired = ChevronExpired;
        exports.ChevronExpiredWarning = ChevronExpiredWarning;
        exports.ChevronInfo = CheckInfo;
        exports.ChevronLeft = CheckLeft;
        exports.ChevronLock = ChevronLock;
        exports.ChevronPlus = ChevronPlus;
        exports.ChevronRight = ChevronRight;
        exports.ChevronSearch = ChevronSearch;
        exports.ChevronUp = ChevronUp;
        exports.CollapseIcon = CollapseIcon;
        exports.CrossIcon = CrossIcon;
        exports.ErrorIcon = ErrorIcon;
        exports.ExistingMerchantIcon = ExistingMerchantIcon;
        exports.ExpandIcon = ExpandIcon;
        exports.FilterIcon = FilterIcon;
        exports.InstallationIcon = InstallationIcon;
        exports.LogoMonerisMerchant = LogoMonerisMerchant;
        exports.NewMerchantIcon = NewMerchantIcon;
        exports.PasswordShowIcon = PasswordShowIcon;
        exports.PlusIcon = PlusIcon;
        exports.ProcessingIcon = ProcessingIcon;
        exports.SortIcon = SortIcon;
        exports.SwirlIcon = SwirlIcon;
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
      });
    })(dist, dist.exports);

    function styleInject(css, ref) {
      if (ref === void 0) ref = {};
      var insertAt = ref.insertAt;

      if (!css || typeof document === 'undefined') {
        return;
      }

      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';

      if (insertAt === 'top') {
        if (head.firstChild) {
          head.insertBefore(style, head.firstChild);
        } else {
          head.appendChild(style);
        }
      } else {
        head.appendChild(style);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }

    var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.card_container {\n  margin: auto;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.84);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 360px;\n  min-height: 175px;\n  border-radius: 5px;\n  background: #ffffff;\n  font-family: avenir_lt_roman;\n  position: relative; }\n  .card_container .card_header {\n    height: 2.375rem;\n    background: #051d33 0% 0% no-repeat padding-box;\n    width: 100%;\n    text-align: center;\n    color: #ffffff;\n    align-items: center;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    padding: 0.5em 0em;\n    position: relative; }\n    .card_container .card_header span {\n      margin: auto;\n      font-size: 1.625rem; }\n    .card_container .card_header .close {\n      position: absolute;\n      right: 0.5rem;\n      bottom: 0.2rem; }\n    .card_container .card_header .minimize {\n      position: absolute;\n      right: 2.5rem;\n      bottom: 0.2rem;\n      color: #c3c3c3; }\n  .card_container .card_body {\n    padding: 1.5rem; }\n";
    styleInject(css_248z);
    /* eslint-disable jsx-a11y/click-events-have-key-events */

    function Card(props) {
      var title = props.title,
          children = props.children,
          showCancel = props.showCancel,
          closeHandler = props.closeHandler,
          minimizeHandler = props.minimizeHandler,
          showMinimize = props.showMinimize;
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "card_container"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "card_header"
      }, /*#__PURE__*/React__default["default"].createElement("span", null, title), showMinimize && /*#__PURE__*/React__default["default"].createElement("span", {
        className: "minimize",
        onClick: function onClick() {
          return minimizeHandler();
        },
        type: "button"
      }, "\u2212"), showCancel && /*#__PURE__*/React__default["default"].createElement("span", {
        className: "close",
        onClick: function onClick() {
          return closeHandler();
        },
        type: "button"
      }, /*#__PURE__*/React__default["default"].createElement(dist.exports.ChevronClose, null))), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "card_body"
      }, children));
    }

    Card.propTypes = {
      title: PropTypes__default["default"].any,
      children: PropTypes__default["default"].any,
      showCancel: PropTypes__default["default"].bool,
      closeHandler: PropTypes__default["default"].func,
      minimizeHandler: PropTypes__default["default"].func,
      showMinimize: PropTypes__default["default"].bool
    };
    Card.defaultProps = {
      title: '',
      children: '',
      showCancel: false,
      closeHandler: function closeHandler() {
        return null;
      },
      minimizeHandler: function minimizeHandler() {
        return null;
      },
      showMinimize: false
    };
    return Card;
  });
  }(dist));

  var Card = /*@__PURE__*/getDefaultExportFromCjs(dist.exports);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

  var Modal = /*#__PURE__*/function (_React$Component) {
    _inherits(Modal, _React$Component);

    var _super = _createSuper(Modal);

    function Modal() {
      var _this;

      _classCallCheck(this, Modal);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "layOverHandler", function () {
        var handleVisibility = _this.props.handleVisibility;
        handleVisibility();
      });

      _defineProperty(_assertThisInitialized(_this), "handleEventBuble", function (event) {
        event.stopPropagation(); // event.preventDefault();
      });

      return _this;
    }

    _createClass(Modal, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var store = this.props.store;

        if (_typeof(store) === 'object' && typeof store.dispatch === 'function') {
          store.dispatch(actions.setModalOpen());
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var store = this.props.store;

        if (_typeof(store) === 'object' && typeof store.dispatch === 'function') {
          store.dispatch(actions.setModalClose());
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            title = _this$props.title,
            children = _this$props.children,
            show = _this$props.show,
            type = _this$props.type,
            showClose = _this$props.showClose,
            overflow = _this$props.overflow,
            className = _this$props.className;
        return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
          className: "".concat(className !== null && className !== void 0 ? className : '', " pop_up_modal_container ").concat(show ? 'show' : 'hide'),
          onClick: function onClick() {
            return _this2.layOverHandler();
          },
          onKeyDown: function onKeyDown() {
            return null;
          },
          role: "dialog",
          tabIndex: "0"
        }, show && /*#__PURE__*/React__default["default"].createElement("div", {
          className: "pop_up_modal_body ".concat(type, " ").concat(overflow),
          onClick: this.handleEventBuble,
          onKeyDown: function onKeyDown() {
            return null;
          },
          role: "dialog",
          tabIndex: "0"
        }, /*#__PURE__*/React__default["default"].createElement(Card, {
          showCancel: showClose,
          closeHandler: this.layOverHandler,
          title: title
        }, children))));
      }
    }]);

    return Modal;
  }(React__default["default"].Component);

  Modal.defaultProps = {
    children: '',
    title: '',
    type: 'sm',
    show: false,
    showClose: true,
    overflow: '',
    className: undefined,
    store: {
      dispatch: function dispatch() {}
    }
  };
  Modal.propTypes = {
    show: PropTypes__default["default"].any,
    handleVisibility: PropTypes__default["default"].func.isRequired,
    children: PropTypes__default["default"].any,
    title: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].string]),
    type: PropTypes__default["default"].string,
    showClose: PropTypes__default["default"].bool,
    overflow: PropTypes__default["default"].string,
    className: PropTypes__default["default"].string,
    store: PropTypes__default["default"].shape({
      dispatch: PropTypes__default["default"].func
    })
  };

  return Modal;

}));
